<template>
  <el-dialog
    :visible.sync="localVisible"
    @close="handleClose"
    :title="'入库单据号：' + (detailData.number||'-')"
    width="80%"
    top="5vh"
    append-to-body
  >
    <!-- 基本信息 -->
    <el-descriptions :column="2" border>
      <el-descriptions-item label="仓单总量"
        >{{ detailData.totalWeight }} KG</el-descriptions-item
      >
      <el-descriptions-item label="已出仓数量"
        >{{ detailData.dispatchedWeight }} KG</el-descriptions-item
      >
      <el-descriptions-item label="仓单余额"
        >{{ detailData.balanceWeight }} KG</el-descriptions-item
      >
      <el-descriptions-item label="仓储公司">{{
        detailData.companyName
      }}</el-descriptions-item>
      <el-descriptions-item label="质押数量"
        >{{ detailData.pledgeWeight }} KG</el-descriptions-item
      >
      <el-descriptions-item label="质押贷款"
        >{{ detailData.loanAmount }} 元</el-descriptions-item
      >
      <el-descriptions-item label="贷款银行">{{
        detailData.bankName
      }}</el-descriptions-item>
    </el-descriptions>

    <!-- 出入库记录表格 -->
    <div
      class="table-title"
      style="
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 500;
        margin-top: 10px;
      "
    >
      出入库记录
    </div>
    <el-table :data="recordList" border style="margin-top: 20px" height="400">
      <el-table-column prop="number" label="单据号" width="160" />
      <el-table-column prop="carNo" label="车牌号" />
      <el-table-column prop="driverName" label="司机" />
      <el-table-column prop="endNetWeight" label="出入仓数量（KG）" />
      <el-table-column prop="grainCategoryName" label="粮食品种" />
      <el-table-column prop="storeName" label="出库仓库" />
      <el-table-column prop="createTime" label="登记时间" width="170" />
      <el-table-column prop="statusName" label="状态">
        <!-- <template #default="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? "已完成" : "进行中" }}
          </el-tag>
        </template> -->
      </el-table-column>
      <el-table-column prop="dataStatus" label="数据状态">
        <template #default="{ row }">
          <el-tag :type="row.dataStatus == 0 ? 'success' : 'danger'">
            {{ row.dataStatus == 0 ? "正常" : "异常" }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getReceiptDetailById } from "@/api/warehousingService";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    receiptId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localVisible: this.visible,
      detailData: {},
      recordList: [],
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
    },
    receiptId(newVal) {
      if (this.visible && newVal) {
        this.getReceiptDetailById();
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
    //获取仓单详情和列表数据  一个接口
    async getReceiptDetailById() {
      console.log(this.receiptId, "仓单id");
      const { data } = await getReceiptDetailById({ id: this.receiptId });
      console.log(data, "仓单详情和列表数据");
      this.detailData = data;
      this.recordList = data.orderItems || [];
      // 避免直接修改 prop，通过事件通知父组件更新数据
      // this.$emit("update:detailData", data);
    },
  },
};
</script>
